module.exports = __webpack_public_path__ + "static/img/gq7.26501979.jpg";